import { useNavigate } from "react-router-dom";
import TicketView from "./view";
import useTicket from "@/hooks/useTicket";
import { useEffect } from "react";

export default function Ticket() {
  const navigate = useNavigate();
  
  const {
    customer, 
    getInvoice, 
    isLoading, 
    errorTickets, 
    errorInvoice, 
    toggleModal, 
    getTickets,
    isVisibleModal,
    generatePDF,
    invoice,
  } = useTicket();

  const goBack = () => navigate("/");

  useEffect(() => {
    getTickets();
  }, []);

  return <TicketView
    tickets={customer?.tickets!}
    openInvoice={getInvoice}
    goBack={goBack}
    isLoading={isLoading}
    errorTickets={errorTickets}
    errorInvoice={errorInvoice}
    tryAgain={() => {
      toggleModal();
      getTickets();
    }}
    toggleModal={toggleModal}
    isVisibleModal={isVisibleModal}
    generatePDF={generatePDF}
    invoice={invoice}
  />;
}
